export default {
    data() {
        return {
            chartColors: {
                total: "#7385EB",
                Vooronderzoek: "#3455DA",
                Webteksten: "#4AE097",
                Wireframes: "#F7FC8F",
                Design: "#F7B2A8",
                Frontend: "#968BF4",
                Backend: "#131F50",
                Staging: "#297B53",
                PM: "#F9FDB7",
                empty: "#71514D"
            }
        };
    },
    methods: {
        format: function(value) {
            if (!value) return "0";

            value = parseFloat(value).toFixed(2);

            return value.replace(".", ",");
        },
        toHours: function(value) {
            let neg = false;
            if(!value) return '0h';

            if(value < 0) {
                neg = true;
            }
            
            value = Math.abs(value);
            
            value *= 3600;

            return (neg ? '-' : '') + Math.floor(value / 3600) + 'h ' + (Math.floor(Math.abs(value) % 3600 / 60) === 0 ? '' : (Math.floor(Math.abs(value) % 3600 / 60) + 'm'));
        },
    }
};
